import { useState, type FormEvent } from 'react';
import { categories } from '@/mocks/site';

interface Props {
  activeCat: string;
  keyword: string;
  sort: string;
  onChangeCat: (id: string) => void;
  onChangeKeyword: (value: string) => void;
  onChangeSort: (value: string) => void;
}

const SORTS = [
  { value: 'latest', label: '按最新归档' },
  { value: 'hot', label: '按热度排序' },
  { value: 'nodes', label: '按时间节点数' },
];

export default function FilterBar({
  activeCat,
  keyword,
  sort,
  onChangeCat,
  onChangeKeyword,
  onChangeSort,
}: Props) {
  const [draft, setDraft] = useState(keyword);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    onChangeKeyword(draft.trim());
  };

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onChangeCat('all')}
          className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
            activeCat === 'all'
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200'
          }`}
        >
          全部圈子
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => onChangeCat(cat.id)}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
              activeCat === cat.id
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="mt-4 flex flex-col gap-3 border-t border-background-200 pt-4 sm:flex-row sm:items-center sm:justify-between">
        <form onSubmit={submit} className="flex w-full items-center rounded-md border border-background-200 bg-background-100 px-3 py-2 sm:max-w-sm">
          <i className="ri-search-line text-sm text-foreground-400"></i>
          <input
            type="search"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="输入关键词，如「录音」「聊天记录」"
            aria-label="搜索合集"
            className="ml-2 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="ml-2 whitespace-nowrap rounded-md bg-secondary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            搜索
          </button>
        </form>

        <div className="flex flex-wrap items-center gap-2">
          {keyword && (
            <button
              type="button"
              onClick={() => {
                setDraft('');
                onChangeKeyword('');
              }}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700 transition-colors hover:bg-primary-200"
            >
              <i className="ri-close-line"></i>
              清除「{keyword}」
            </button>
          )}
          <label className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-sort-desc"></i>
            <select
              value={sort}
              onChange={(e) => onChangeSort(e.target.value)}
              aria-label="排序方式"
              className="cursor-pointer rounded-md border border-background-200 bg-background-100 px-3 py-1.5 text-sm text-foreground-800 outline-none focus:border-primary-300"
            >
              {SORTS.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>
    </div>
  );
}